import React from 'react';
import {
  Button, Select, DatePicker, Divider, Icon, Drawer,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  Box, Flex, ShowIf, Text,
} from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import {
  establecerPropiedadDeCabecera,
  expandirEncargo,
  contraerEncargo, onClickEliminarCliente,
} from '../../../../state/actions/creators/encargos.creador.actioncreator';
import SelectBorderless from '../../../shared/components/dataEntry/SelectBorderless';
import { obtenerEstadoRequestDesdeSaga } from '../../../../helpers/sagaStatus.helper';
import { cabeceraEncargoCreacionType } from '../../types/encargo.creacion.types';
import PopoverNumeroDeLote from './PopoverEditorNumero.dataentry';
import UsuariosDrawer from '../../../app/components/Usuarios.drawer';
import DateFormat from '../../../shared/components/dataDisplay/DateFormat';

const { Option } = Select;
function generarCamposFormulario({ form }) {
  return (
    form.map(({
      order, translationId, content, showIf,
    }) => (
      <ShowIf condition={showIf === undefined || showIf}>
        <Flex alignItems="baseline" width="100%" key={order} my="16" height="16px">
          { translationId ? (
            <Box>
              <Text fontSize="16" color="#777572" translationId={translationId} />
              <Text color="#777572" fontSize="16">:</Text>
            </Box>
          ) : null }
          { content }
        </Flex>
      </ShowIf>
    ))
  );
}

class CabeceraEncargo extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { motivosCompra, tiposEncargo } = props;
    this.OptionsMotivosCompra = motivosCompra.filter(e => !e.inactivo).map(({ id, descripcion }) => <Option key={id} value={id}>{descripcion}</Option>);
    this.OptionsTipoDeEncargo = tiposEncargo.map(({ id, descripcion }) => <Option key={id} value={id}>{descripcion}</Option>);
    this.state = {
      atendidoPorVisible: false,
    };
  }

  render() {
    const { atendidoPorVisible } = this.state;
    const {
      onClickSeleccionarCliente, establecerPropiedadDeCabecera, usuarios,
      estadoPeticionCargarGraduacion, encargoUUID, cabecera, nombreEncargo,
      expandido, expandirEncargo, contraerEncargo, erroresFormulario, motivosCompra,
      onClickEliminarCliente, modo, tiposEncargo,
    } = this.props;
    const {
      gestorId, motivoVisitaId, tipoEncargoId, cliente, fechaCreacionPretty, fechaCreacion, fechaEntrega, numeroTalon,
    } = cabecera;
    const { id: clienteId, nombreCompleto: clienteNombreCompleto } = cliente;
    const tieneClienteSeleccionado = clienteId !== undefined && clienteId !== null;
    const erroresEnTipoEncargo = (erroresFormulario.tipoEncargoId !== undefined && erroresFormulario.tipoEncargoId !== null && erroresFormulario.tipoEncargoId.hasErrors === true);
    const atendidoPorSeleccionado = usuarios.find(({ id }) => id === gestorId);
    const motivoVisitaSeleccionado = motivosCompra.find(({ id }) => id === motivoVisitaId);
    const tipoEncargoSeleccionado = tiposEncargo.find(({ id }) => id === tipoEncargoId)
    const DefinicionCamposIzquierda = [
      {
        order: 1,
        translationId: 'encargos.cliente',
        content: (
          <>
            <Flex className="focusable" ml="8" justifyContent="space-between" alignItems="baseline" flex="1" mr="24px" onClick={modo !== 'mostrar' ? () => onClickSeleccionarCliente(encargoUUID) : null}>
              <ShowIf condition={tieneClienteSeleccionado}>
                <style>{'.focusable:hover .anticon{color: rgba(0, 0, 0, 0.45) !important;'}</style>
                <Text>{clienteNombreCompleto}</Text>
                <ShowIf condition={modo !== 'mostrar'}>
                  <Icon
                    type="close-circle"
                    theme="filled"
                    style={{ color: '#BFBFBF' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onClickEliminarCliente({ cliente, encargoUUID });
                    }}
                  />
                </ShowIf>
              </ShowIf>
              <ShowIf condition={!tieneClienteSeleccionado && modo !== 'mostrar'}>
                <Text translationId="encargos.cliente_generico" />
                <Icon style={{ fontSize: '12px' }} type="down" />
              </ShowIf>
            </Flex>
          </>
        ),
      },
      {
        order: 2,
        translationId: 'encargos.motivo_de_visita',
        showIf: expandido,
        content: (
          <Box ml="8" display="inline-block" flex="1" mr="24px">
            <ShowIf condition={modo !== 'mostrar'}>
              <SelectBorderless
                minWidth="100%"
                options={this.OptionsMotivosCompra}
                value={motivoVisitaId}
                onChange={valor => establecerPropiedadDeCabecera({ encargoUUID, valor, nombre: 'motivoVisitaId' })}
              />
            </ShowIf>
            <ShowIf condition={modo === 'mostrar'}>
              <ShowIf condition={motivoVisitaSeleccionado}>
                <Text>{motivoVisitaSeleccionado ? motivoVisitaSeleccionado.descripcion : null}</Text>
              </ShowIf>
              <ShowIf condition={!motivoVisitaSeleccionado}>
                <Text translationId="encargos.sin_motivo"/>
              </ShowIf>
            </ShowIf>
          </Box>
        ),
      },

    ];

    const DefinicionCamposDerecha = [
      {
        order: 1,
        translationId: 'encargos.atendido_por',
        content: (
          <Flex ml="8" justifyContent="space-between" alignItems="baseline" flex="1" mr="0" onClick={modo !== 'mostrar' ? () => this.setState({ atendidoPorVisible: true }) : null}>
            <Text>{atendidoPorSeleccionado.nombreCompleto}</Text>
            <ShowIf condition={modo !== 'mostrar'}>
              <Icon style={{ width: '12px', height: '14px', fontSize: '12px' }} type="down" />
            </ShowIf>
          </Flex>

        ),
      },
      {
        order: 2,
        translationId: 'encargos.tipo_de_encargo',
        showIf: expandido,
        content: (
          <Box ml="8" display="inline-block" flex="1">
            <ShowIf condition={modo !== 'mostrar'}>
              <SelectBorderless
                minWidth="100%"
                options={this.OptionsTipoDeEncargo}
                value={tipoEncargoId}
                hasErrors={erroresEnTipoEncargo}
                onChange={valor => establecerPropiedadDeCabecera({ encargoUUID, valor, nombre: 'tipoEncargoId' })}
              />
            </ShowIf>
            <ShowIf condition={modo === 'mostrar'}>
              <Text translationId={tipoEncargoSeleccionado ? undefined : 'encargos.tipo_no_definido'}>{tipoEncargoSeleccionado ? tipoEncargoSeleccionado.descripcion : null}</Text>
            </ShowIf>
          </Box>
        ),
      },
      {
        order: 3,
        translationId: 'encargos.numero_talon',
        showIf: expandido,
        content: (
          <Flex ml="8" justifyContent="space-between" alignItems="baseline" flex="1" mr="0">
            <ShowIf condition={modo !== 'mostrar'}>
              <PopoverNumeroDeLote
                title={<Text pt="4" translationId="encargos.numero_talon" fontWeight="semibold" />}
                label={<Text fontSize="12" translationId="encargos.introducir_talon" />}
                numero={numeroTalon}
                onAplicar={({ valor }) => {
                  establecerPropiedadDeCabecera({
                    encargoUUID,
                    valor: (valor === '') ? valor : parseInt(valor),
                    nombre: 'numeroTalon',
                  });
                }}
              />
            </ShowIf>
            <ShowIf condition={modo === 'mostrar'}>
              <ShowIf condition={numeroTalon}>
                <Text>{numeroTalon}</Text>
              </ShowIf>
              <ShowIf condition={!numeroTalon}>
                <Text translationId="encargos.sin_numero_talon"/>
              </ShowIf>
            </ShowIf>
          </Flex>
        ),
      },
      {
        order: 4,
        showIf: expandido,
        translationId: 'encargos.entrega_estimada',
        content: (
          <Box display="inline-block" ml="8" flex="1">
            <ShowIf condition={modo !== 'mostrar'}>
              <style>{'.noBorder .ant-input-sm { height: 16px;} .noBorder input{border-style: none; box-shadow: none !important;} .noBorder .ant-calendar-picker-icon{right:0 !important;} .noBorder .ant-calendar-picker-clear{right:0 !important;}'}</style>
              <DatePicker
                value={fechaEntrega}
                className="noBorder"
                size="small"
                format="DD-MM-YYYY"
                onChange={valor => establecerPropiedadDeCabecera({ encargoUUID, valor, nombre: 'fechaEntrega' })}
                disabledDate={current => moment().add(-1, 'days') >= current}
                style={{ width: '100%' }}
              />
            </ShowIf>
            <ShowIf condition={modo === 'mostrar'}>
              <DateFormat year="numeric" month="2-digit" day="2-digit" value={fechaCreacion} />
            </ShowIf>
          </Box>
        ),
      },
    ];

    const JSXFormularioIzquierda = generarCamposFormulario({ form: DefinicionCamposIzquierda });
    const JSXFormularioDerecha = generarCamposFormulario({ form: DefinicionCamposDerecha });

    const deshabilitarSeleccionCliente = estadoPeticionCargarGraduacion.running === true;
    return (
      <Box>
        <UsuariosDrawer
          onSeleccionado={({ id }) => { establecerPropiedadDeCabecera({ encargoUUID, valor: id, nombre: 'gestorId' }); this.setState({ atendidoPorVisible: false }); }}
          onClose={() => this.setState({ atendidoPorVisible: false })}
          visible={atendidoPorVisible}
          usuarios={usuarios}
        />
        <Box>
          <Box>
            <Text fontSize="20" fontWeight="semibold" mr="8">{nombreEncargo}</Text>
            <Box my="8" height="16px">
              <Text fontSize="14" translationId="generico.creado_el" color="#777572" />
              <Box display="inline-block">
                <Text ml="4" fontSize="14" color="#777572">{ fechaCreacionPretty }</Text>
              </Box>
            </Box>
          </Box>
          <Divider style={{ margin: '16px 0 9px 0' }} />
          <Flex justifyContent="space-between" alignItems="baseline">
            <Text upperCase fontSize="12" translationId="encargos.datos_encargo" color="#777572" />
            {/* <Button style={{ paddingRight: 0 }} type="link" onClick={() => (expandido ? contraerEncargo({ encargoUUID }) : expandirEncargo({ encargoUUID }))}><Text fontSize="14" translationId={expandido ? 'generico.menos_datos' : 'generico.mas_datos'} color="#049BDD" /></Button> */}
          </Flex>
          <TwoColumnsFlexLayout
            mt="8"
            leftContent={(
              <Box>
                <Text fontSize="16" fontWeight="semibold" translationId="encargos.informacion_cliente" />
                { JSXFormularioIzquierda }
              </Box>
              )}
            rightContent={(
              <Box>

                <Text fontSize="16" fontWeight="semibold" translationId="encargos.informacion_encargo" />
                { JSXFormularioDerecha }
              </Box>
              )}
          />
        </Box>
      </Box>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    establecerPropiedadDeCabecera,
    onClickEliminarCliente,
    expandirEncargo,
    contraerEncargo,
  }, dispatch);
}

const mapStateToProps = (state) => {
  const { core, sagas } = state;
  const { tiposEncargo } = core;
  const { motivosCompra, usuariosActivosDeMiTienda } = core;
  return {
    tiposEncargo,
    motivosCompra,
    usuarios: usuariosActivosDeMiTienda,
    estadoPeticionCargarGraduacion: obtenerEstadoRequestDesdeSaga(sagas, 'ENCARGOS_CREACION_BUSCAR_GRADUACION'),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CabeceraEncargo);

CabeceraEncargo.propTypes = {
  cabecera: cabeceraEncargoCreacionType.isRequired,
  encargoUUID: PropTypes.string.isRequired,
  nombreEncargo: PropTypes.string.isRequired,
  expandido: PropTypes.bool,
  modo: PropTypes.string.isRequired,
  establecerPropiedadDeCabecera: PropTypes.func.isRequired,
  motivosCompra: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    descripcion: PropTypes.string.isRequired,
  })),
  tiposEncargo: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    descripcion: PropTypes.string.isRequired,
  })),
  usuarios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    nombreCompleto: PropTypes.string.isRequired,
  })),
  onClickSeleccionarCliente: PropTypes.func.isRequired,
  onClickEliminarCliente: PropTypes.func.isRequired,
  estadoPeticionCargarGraduacion: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
  }),
  expandirEncargo: PropTypes.func.isRequired,
  contraerEncargo: PropTypes.func.isRequired,
  erroresFormulario: PropTypes.shape({}),
};
CabeceraEncargo.defaultProps = {
  estadoPeticionCargarGraduacion: {
    running: false,
    success: null,
  },
  motivosCompra: [],
  tiposEncargo: [],
  usuarios: [],
  expandido: true,
  erroresFormulario: {},
};
